import { smartLockerPackageConstants } from "@constants";

const initalState = {
  query: {
    loading: false,
    constructionUuid: null,
    condition: {},
    statistics: {},
    total: 0,
    items: [],
    fail: null
  }
};

export const smartLockerPackages = (state = initalState, action) => {
  switch (action.type) {
    case smartLockerPackageConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: true
        }
      };
    case smartLockerPackageConstants.GET_ALL_SUCCESS:
      const { total, config, items, statistics, condition, constructionUuid } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          constructionUuid,
          condition,
          total,
          statistics,
          config,
          items
        }
      };
    case smartLockerPackageConstants.GET_ALL_FAILURE:
      const { error } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          fail: error
        }
      };
    case smartLockerPackageConstants.RESET_ALL_SUCCESS:
      return initalState;
    default:
      return state;
  }
};
